export default "__VITE_ASSET__MsLYmaEv__"